import { Quaternion } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { MoveMeasure } from './tools';
import { AbstractInteractors } from "./interactors";
import { EditMeasures } from './../cmd/EditMeasure';
import { MeasureEnding } from './../mdl/Measure';
import { Util } from "../utils/Util";
import { PI_DIV2 } from "@egr/wcf/modules/utils/math";
import { VECTOR3_X, perpendicularVector2 } from "@egr/wcf/modules/core/utils/MathUtils";
import { getRotationQuaternion } from '@egr/wcf/modules/core/utils/MeshUtils';
export class MeasureInteractors extends AbstractInteractors {
    constructor(pRoomManager, pMeasure) {
        super(pRoomManager);
        this.mMeasure = pMeasure;
        this.mLengthInteractors = [null];
    }
    showInteractors(pShow) {
        this.clear();
        if (!pShow || this.mApp.model.selection.length !== 1)
            return;
        this.mInteractorManager.enabled = true;
        let tdir_perp = Util.to3d(perpendicularVector2(this.mMeasure.measureDirection).negate());
        let tstart = Util.to3d(this.mMeasure.startPoint);
        tstart.y = 0.02;
        let tend = Util.to3d(this.mMeasure.endPoint);
        tend.y = 0.02;
        let tCenter = Vector3.Center(tstart, tend);
        tCenter.y = 0.02;
        let toffsetPos = Util.to3d(this.mMeasure.endPoint.subtract(this.mMeasure.measureDirection.scale(0.3)));
        let tdiff = this.mMeasure.LineOffset > 0 ? -0.1 : 0.1;
        toffsetPos.addInPlace(tdir_perp.scale(this.mMeasure.LineOffset + tdiff));
        toffsetPos.y = 0.02;
        let t3dRotation = getRotationQuaternion(this.mMeasure.node).clone();
        t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
        this._updateLengthInteractors();
        //move start
        let tInteractor = this.createInteractor("dot-interactor", tstart, null, 0, t3dRotation);
        tInteractor.onTriggerAction = () => this.startEditMeasure(MoveMeasure.Mode.MoveStart);
        //move end
        tInteractor = this.createInteractor("dot-interactor", tend, null, 0, t3dRotation);
        tInteractor.onTriggerAction = () => this.startEditMeasure(MoveMeasure.Mode.MoveEnd);
        //move measure
        tInteractor = this.createInteractor("move-interactor", tCenter, null, 0, t3dRotation);
        tInteractor.onTriggerAction = () => this.startEditMeasure(MoveMeasure.Mode.MoveMeasure);
        //move line offset
        tInteractor = this.createInteractor("arrowH-interactor", toffsetPos, null, 0, t3dRotation);
        tInteractor.onTriggerAction = () => this.startEditMeasure(MoveMeasure.Mode.LineOffset);
    }
    clear() {
        this.mInteractorManager.clear();
        this.mInteractorManager.enabled = false;
        this.mLengthInteractors = [null];
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _updateLengthInteractors() {
        while (this.mLengthInteractors.length > 1 && this.mLengthInteractors[0] != null) {
            this.mInteractorManager.removeInteractor(this.mLengthInteractors[1]);
            this.mLengthInteractors[1] = null;
            this.mInteractorManager.removeInteractor(this.mLengthInteractors[0]);
            this.mLengthInteractors[0] = null;
        }
        this.mInteractorManager.enabled = true;
        let t3dRotation = getRotationQuaternion(this.mMeasure.node).clone();
        t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
        let tdir_perp = Util.to3d(perpendicularVector2(this.mMeasure.measureDirection).negate());
        let tTextPos = this.mMeasure.TextPosition;
        tTextPos.y = 0.02;
        //invisible text interactor
        let tLength = this.mMeasure.getMeasureLength();
        let talternativeText = this.mMeasure.AlternativeText;
        if (this.mLTInteractor != null) {
            this.mInteractorManager.removeInteractor(this.mLTInteractor);
            this.mLTInteractor = null;
        }
        this.mLTInteractor = this.createMeasureTextInteractor(tTextPos, "", VECTOR3_X, tdir_perp, 8, t3dRotation, false);
        if (this.mLTInteractor != null) {
            if (this.mMeasure.isLableLength) {
                this.mLTInteractor.onTriggerAction = () => this.showInputField(MeasureInteractors.INPUT_LENGTH_L, tLength, this.mLTInteractor);
            }
            else {
                this.mLTInteractor.onTriggerAction = () => this.showInputFieldText(MeasureInteractors.INPUT_ALTERNATIVETEXT, talternativeText, this.mLTInteractor);
            }
        }
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    handleInputField(pId, pOldLength, pNewLength, pInteractor) {
        switch (pId) {
            case MeasureInteractors.INPUT_LENGTH_L:
                this.setMeasureLength(pNewLength, true, pInteractor);
                break;
            case MeasureInteractors.INPUT_LENGTH_R:
                this.setMeasureLength(pNewLength, false, pInteractor);
                break;
            default:
                break;
        }
        this._updateLengthInteractors();
    }
    handleInputFieldText(pId, pOldText, pNewText, pInteractor) {
        switch (pId) {
            case MeasureInteractors.INPUT_ALTERNATIVETEXT:
                this.mMeasure.setText(pNewText);
                break;
            default:
                break;
        }
        this._updateLengthInteractors();
    }
    startEditMeasure(pMode) {
        let tTool = new MoveMeasure(this.mRoomManager);
        tTool.initialize(pMode, this.mMeasure);
        this.mApp.tools.startTool(tTool);
    }
    setMeasureLength(pLength, pLeftMeasureSide, pInteractor) {
        let tScaleInStartDirection = true;
        if (pInteractor.angleFlipped)
            tScaleInStartDirection = !tScaleInStartDirection;
        let tCmd = new EditMeasures(this.mRoomManager);
        try {
            let tOldLength;
            if (pLeftMeasureSide) {
                tOldLength = this.mMeasure.getMeasureLength();
            }
            else {
                tOldLength = this.mMeasure.getMeasureLength();
            }
            let tDeltaLength = pLength - tOldLength;
            let tV1 = null;
            let tV2 = null;
            let tEnding = null;
            if (tScaleInStartDirection) {
                tV1 = this.mMeasure.endPoint;
                tV2 = this.mMeasure.startPoint;
                tEnding = MeasureEnding.Start;
            }
            else {
                tV1 = this.mMeasure.startPoint;
                tV2 = this.mMeasure.endPoint;
                tEnding = MeasureEnding.End;
            }
            let tDir = tV2.subtract(tV1).normalize();
            let tV = tV1.add(tDir.scale(this.mMeasure.getMeasureLength() + tDeltaLength));
            if (tEnding === MeasureEnding.Start)
                this.mMeasure.setStartPoint(tV);
            else
                this.mMeasure.setEndPoint(tV);
        }
        finally {
            this.mApp.commands.executeCommand(tCmd);
        }
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
MeasureInteractors.INPUT_LENGTH_L = "Measure:length_left";
MeasureInteractors.INPUT_LENGTH_R = "Measure:length_right";
MeasureInteractors.INPUT_ALTERNATIVETEXT = "Measure:alternativeText";
